"use strict";

exports.__esModule = true;
exports.EditableTabsElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _common = require("../common");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _styles = require("./styles");
var _helpers = require("./helpers");
var _Env = require("../../Env");
var _dec, _dec2, _class;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays a list of tabs.
 */
var EditableTabsElement = exports.EditableTabsElement = (_dec = _ConfigurableLayout.ElementEditorContext.withContext, _dec2 = _Env.EnvContext.withContext, _dec(_class = _dec2(_class = /*#__PURE__*/function (_Component) {
  function EditableTabsElement(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      selectedTabId: 0,
      tabsListDimensions: _helpers.defaultTabsListDimensions
    };
    _this.handleTabChange = function (selectedTabId) {
      _this.props.elementEditor.selectElementAt(_this.props.path.concat("children", selectedTabId));
    };
    _this.tabsListRef = /*#__PURE__*/(0, _react.createRef)();
    return _this;
  }

  // The ref is still empty while the first render runs, so measure after every
  // commit instead: the tab list's size is subtracted from the panel size, and
  // TabsWrapper clips whatever the panel overshoots by.
  _inheritsLoose(EditableTabsElement, _Component);
  EditableTabsElement.getDerivedStateFromProps = function getDerivedStateFromProps(_ref) {
    var path = _ref.path,
      elementEditor = _ref.elementEditor;
    var selectedPath = elementEditor.selectedPath;
    if (!(0, _ConfigurableLayout.getPathContainsPath)(path, selectedPath) || path.length >= selectedPath.length) {
      return null;
    }
    return {
      selectedTabId: selectedPath[path.length + 1]
    };
  };
  var _proto = EditableTabsElement.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.measureTabsList();
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    this.measureTabsList();
  };
  _proto.measureTabsList = function measureTabsList() {
    var measured = (0, _helpers.getTabsListDimensions)(this.tabsListRef.current);
    var tabsListDimensions = this.state.tabsListDimensions;
    if (measured.height !== tabsListDimensions.height || measured.width !== tabsListDimensions.width) {
      this.setState({
        tabsListDimensions: measured
      });
    }
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      id = _this$props.id,
      orientation = _this$props.orientation,
      children = _this$props.children,
      env = _this$props.env;
    var _this$state = this.state,
      selectedTabId = _this$state.selectedTabId,
      tabsListDimensions = _this$state.tabsListDimensions;
    return /*#__PURE__*/_react["default"].createElement(_styles.TabsWrapper, (0, _common.getWidgetPositionProps)(this.props), /*#__PURE__*/_react["default"].createElement(_core.Tabs, {
      ref: this.tabsListRef,
      id: id,
      vertical: orientation === "vertical",
      onChange: this.handleTabChange,
      large: true,
      selectedTabId: selectedTabId
    }, children.map(function (child, index) {
      var _child$props, _child$props2;
      if ((_child$props = child.props) != null && _child$props.featureFlag && !env.featureFlags.includes((_child$props2 = child.props) == null ? void 0 : _child$props2.featureFlag)) {
        return null;
      }
      return (0, _helpers.RenderTabContent)({
        child: child,
        index: index,
        props: _this2.props,
        tabsListDimensions: tabsListDimensions,
        editableTabsWidget: true
      });
    })));
  };
  return EditableTabsElement;
}(_react.Component)) || _class) || _class);